import { useContext, useState } from "react"
import { GameContext } from "../context/globalContext"

export default function Score({player, gamemode}) {
    const [options, setOptions] = useState(JSON.parse(localStorage.getItem('options')))

    const {score, songIndex, songsContext} = useContext(GameContext)
    
    return (
        <div className="score">
            <h3>SONG: {songIndex ? songIndex : 1}{gamemode === 'standard' && (parseInt(options.numberOfSongs) >= songsContext.length) ? `/${songsContext.length}` : gamemode === 'standard' ? `/${options.numberOfSongs}` : null}</h3>
            <h3>SCORE: {score ? score : 0}</h3>
        </div>
    )
}